import React from "react";

export function TotalRevenueIcon() {
  return (
    <svg
      version="1.1"
      width="26"
      height="26"
      viewBox="0 0 64 64"
    >
      <g>
        {/* Dollar Coin */}
        <circle
          cx="32"
          cy="32"
          r="28"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M38 24c0-3-2.5-5-6-5s-6 2-6 5 2 4 6 5c4 1 6 2 6 5s-2.5 5-6 5-6-2-6-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <line
          x1="32"
          y1="16"
          x2="32"
          y2="48"
          stroke="currentColor"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}
